import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAppSelector } from '@/store';

interface AdminGuardProps {
  allowedRoles?: string[];
  children: ReactNode;
}

/**
 * Route guard for admin pages
 * Redirects to login if not authenticated
 * Optionally checks for specific roles
 */
export function AdminGuard({ allowedRoles, children }: AdminGuardProps) {
  const location = useLocation();
  const { user, token } = useAppSelector((state) => state.adminAuth);

  // Not authenticated - redirect to login
  if (!token || !user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Role check (if specified)
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}
